import { configureStore } from '@reduxjs/toolkit';

import customerSliceReducer from '../slices/Customer/customerSlice';
import customerOrdersSliceReducer from '../slices/Customer/customerOrdersSlice';
import orderSummarySliceReducer from '../slices/OrderSummary/orderSummarySlice';
import systemSliceReducer from '../slices/System/systemSlice';
import wideFormSliceReducer from '../slices/WideForm/wideFormSlice';
import eventFilterSliceReducer from '../slices/Customer/eventFilterSlice';


export const store = configureStore({
    reducer: {
        customer: customerSliceReducer,
        customerOrders: customerOrdersSliceReducer,
        orderSummary: orderSummarySliceReducer,
        system: systemSliceReducer,
        wideForm: wideFormSliceReducer,
        eventFilter: eventFilterSliceReducer
    }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch